import { EventEmitter } from '@angular/core';
import { Link } from './link';
import { Node } from './node';
import * as d3 from 'd3';

// INFO: properties that can be tweaked for achieving graph changes charge, gravity, manybody, center etc
const FORCES = {
    LINKS: 1 / 50, // INFO: No more used
    COLLISION: 1,
    CHARGE: -30, // INFO: Increase negative value to disperse nodes
};

export class ForceDirectedGraph {
    public ticker: EventEmitter<d3.Simulation<Node, Link>> = new EventEmitter();
    // TODO: not working to be revisited
    //public nodeClicked: EventEmitter<d3.Simulation<Node, Link>> = new EventEmitter();
    public simulation!: d3.Simulation<any, any>;

    public nodes: Array<Node> = [];
    public links: Array<Link> = [];
    public options: { width: any; height: any };
    interval: any;

    constructor(nodes: Array<Node>, links: Array<Link>, options: { width: any; height: any }) {
        this.nodes = nodes;
        this.links = links;
        // Added for setting node position
        const isMobile = window.innerWidth < 768 ? true : false;
        if (isMobile) {
            options.width = options.width + 250;
        }
        this.options = options;

        this.initSimulation(options);
        this.interval = setTimeout(() => {
            //this.MultilineNodeText();
        }, 100);
    }

    connectNodes(source: Node, target: Node) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        //@ts-expect-error
        if (!this.nodes[source] || !this.nodes[target]) {
            throw new Error('One of the nodes does not exist');
        }

        const link = new Link(source, target);
        this.simulation.stop();
        this.links.push(link);
        this.simulation.alphaTarget(0).restart();

        this.initLinks();
    }

    initNodes() {
        if (!this.simulation) {
            throw new Error('simulation was not initialized yet');
        }
        //const nodeClicked = this.nodeClicked;
        // INFO: Below custom code added to position nodes by level. Review and tweak logic based on fx, fy in case force properties are overriding
        // TODO: review and tweak logic based on fx, fy in case force properties are overriding
        this.nodes.forEach((d, i) => {
            d.x = this.options.width / 2 + i;
            d.y = this.options.height / 2 + 100 * d.nodeLevel;
            if (i == 0) {
                d.fx = this.options.width / 2.7;
                d.fy = this.options.height / 1.6;
            }
        });

        this.simulation.nodes(this.nodes);
    }

    initLinks() {
        if (!this.simulation) {
            throw new Error('simulation was not initialized yet');
        }

        this.simulation.force(
            'link',
            d3
                .forceLink(this.links)
                .id((d: { [x: string]: any }) => d['id'])
                //.distance((d: { [x: string]: any; }) => d['value']) // If the link distance should be based on some logic
                .distance(-0.5) // TODO: Re-evaluate of we should have some value
                .strength(0.2),
        );

        /* Initial code
    this.simulation.force('links',
      d3.forceLink(this.links)
        .id((d: { [x: string]: any; }) => d['id'])xx
        .strength(FORCES.LINKS)
    ); */
    }

    initSimulation(options: { width: any; height: any }) {
        if (!options || !options.width || !options.height) {
            throw new Error('missing options when initializing simulation');
        }

        /** Creating the simulation */
        if (!this.simulation) {
            const ticker = this.ticker;

            this.simulation = d3
                .forceSimulation()
                .force(
                    'charge',
                    d3
                        .forceManyBody()
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-expect-error
                        .strength((d) => -30 * d['r']),
                )
                .force(
                    'collide',
                    d3
                        .forceCollide()
                        .strength(0.3)
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-expect-error
                        // TODO: try out changes in iterations
                        .radius((d) => d['r'] + 20)
                        .iterations(1),
                );

            // Connecting the d3 ticker to an angular event emitter
            this.simulation.on('tick', function () {
                ticker.emit(this);
            });

            this.initNodes();

            this.initLinks();
        }

        /** Updating the central force of the simulation */
        /** center the zoom of SVG */
        // this.simulation.force('center', d3.forceCenter(options.width / 2.7, options.height / 1.6));

        /** Restarting the simulation internal timer */

        this.simulation.restart();
    }

    //following function split the graph text into multiline.
    MultilineNodeText() {
        const nodeCount = d3.select('svg').selectAll('text').nodes().length;

        if (nodeCount > 0) {
            const separation = 12;
            const maxLength = 25;
            const textX = 0;
            d3.select('svg')
                .selectAll('text')
                .nodes()
                .forEach((d) => {
                    if (d3.select(d).text().replace('\n', '').trim() != '') {
                        const lines = this.wordwrap2(d3.select(d).text().replace('\n', '').trim(), maxLength, '\n', false).split('\n');
                        d3.select(d).html('');
                        for (let i = 0; i < lines.length; i++) {
                            d3.select(d).append('tspan').attr('dy', separation).attr('x', textX).text(lines[i]);
                            d3.select(d).attr('transform', 'translate(0,' + ((separation * lines.length) / 2) * -1 + ')');
                        }
                    }
                });
        }
    }
    wordwrap2(str: any, width: any, brk: any, cut: any) {
        brk = brk || '\n';
        width = width || 25;
        cut = cut || false;
        if (!str) {
            return str;
        }
        const regex = '.{0,' + width + '}(\\s|$)' + (cut ? '|.{' + width + '}|.+$' : '|\\S+?(\\s|$)');
        return str.match(RegExp(regex, 'g')).join(brk);
    }
}
